import * as React from "react";
import { App } from "./modules/App";
import { createRoot } from "react-dom/client";
// import * as Sentry from "@sentry/react";

// Sentry.init({
//   dsn: "https://30ead3355eb389ed6a4ad4b6b4bfb8a6@o4511040294486016.ingest.de.sentry.io/4511040295993424",
//   // Setting this option to true will send default PII data to Sentry.
//   // For example, automatic IP address collection on events
//   sendDefaultPii: false,
// });

const root = createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
